import axios, { AxiosError } from "axios";

const MAX_ERROR_LENGTH = 150;

const truncate = (message: string, max = MAX_ERROR_LENGTH): string =>
  message.length > max ? `${message.slice(0, max)}...` : message;

const extractMessage = (obj: unknown): string | null => {
  if (typeof obj !== "object" || obj === null) return null;
  if ("message" in obj && typeof obj.message === "string") {
    return obj.message;
  }
  if ("error" in obj && typeof obj.error === "object" && obj.error !== null) {
    if ("message" in obj.error && typeof obj.error.message === "string") {
      return obj.error.message;
    }
  }
  if ("detail" in obj && typeof obj.detail === "string") return obj.detail;
  if ("errors" in obj && Array.isArray(obj.errors) && obj.errors[0]?.message) {
    return obj.errors[0].message;
  }

  return null;
};

export const getError = (error: unknown): string | null => {
  if (axios.isCancel(error)) {
    return "Request was canceled";
  }

  if (error instanceof AxiosError) {
    const serverError = error.response?.data;

    if (error?.response?.status === 401) {
      return null;
    }

    const message = extractMessage(serverError);

    if (message) {
      return truncate(message);
    }

    return error.response?.statusText || "Something went wrong";
  }

  if (error instanceof Error) {
    return truncate(error.message);
  }

  if (typeof error === "object") {
    const message = extractMessage(error);

    if (message) {
      return truncate(message);
    }
  }

  return "An unknown error occurred";
};
